'use strict';

(function () {
  angular
    .module('specsguardApp')
    .factory('User', User);

  User.$inject = ['$resource'];

  function User($resource) {

    return $resource('/api/user/:id/:controller', {
      id: '@_id'
    },
    {
      getAll: {
        method: 'GET',
        isArray: true,
      },
      save: {
        method: 'POST',
        isArray: true
      },
      update: {
        method: 'PUT',
        isArray: true
      },
      updateUserTenant: {
        method: 'PUT',
        isArray: true
      },
      updateOne: {
        method: 'PUT'
      },
      changePassword: {
        method: 'PUT',
        params: {
          controller: 'password'
        }
      },
      activate: {
        method: 'POST',
        params: {
          controller: 'activate'
        }
      },
      reactivate: {
        method: 'PUT',
        params: {
          controller: 'reactivate'
        }
      },
      remove: {
        method: 'DELETE'
      },
      getMe: {
        method: 'GET',
        params: {
          id: 'me'
        }
      },
      getUserById: {
        method: 'POST',
        params: {
          controller: 'getuser'
        }
      },
      tenants: {
        method: 'GET',
        params: {
          id: 'tenants'
        },
        isArray: true
      }

      /*
      Angular $resource is een decorator die de volgende methods toevoegt:

      .get
      .save
      .query
      .remove
      .delete

      zie : https://docs.angularjs.org/api/ngResource/service/$resource
       */
    });
  }

})();
